export default {
  SET_DATA_LEAD (state, data) {
    state.dataLead = data
  },
  CLEAR_DATA (state, data) {
    state.dataLead.leadId = ''
    state.dataLead.customerName = ''
    state.dataLead.merchantName = ''
    state.dataLead.email = ''
    state.dataLead.mobile = ''
    state.dataLead.address = ''
    state.dataLead.cityCode = ''
    state.dataLead.city = ''
    state.dataLead.districtCode = ''
    state.dataLead.district = ''
    state.dataLead.note = ''
  }
}
